import { setContext as rawSetContext, getContext as rawGetContext } from "svelte";
export function setContext(key, value) {
  return rawSetContext(key, value);
}
export function getContext(key) {
  return rawGetContext(key);
}